import './Dashboard.css';

// Demo data
const STATS = [
  { label: 'Linked Devices', value: 3, detail: '1 active now' },
  { label: 'Connections', value: 5, detail: 'TakeTitle +4' },
  { label: 'Unread Messages', value: 12, detail: '3 platforms' },
  { label: 'Status', value: '● Healthy', detail: '', isStatus: true },
];

const PENDING_ACTIONS = [
  {
    id: '1',
    type: 'device.link',
    title: 'Device Link Request',
    description: 'MacBook Pro wants to link to your account',
    timestamp: '5 minutes ago',
  },
  {
    id: '2',
    type: 'guardian.accept',
    title: 'Guardian Approval Request',
    description: 'Alice wants you as their recovery guardian',
    timestamp: '2 hours ago',
  },
];

const RECENT_ACTIVITY = [
  { event: 'Device linked: iPhone 15 Pro', time: 'Today, 10:23 AM', status: 'success' },
  { event: 'Platform connected: TakeTitle', time: 'Yesterday, 3:45 PM', status: 'success' },
  { event: 'Guardian added: Bob', time: 'Jan 14, 2:30 PM', status: 'success' },
];

export default function Dashboard() {
  return (
    <div className="dashboard animate-in">
      {/* Account Overview */}
      <section className="dashboard-section">
        <h2 className="section-title">Account Overview</h2>
        <div className="stats-grid">
          {STATS.map((stat, i) => (
            <div key={i} className="stat-card card">
              <div className={`stat-value ${stat.isStatus ? 'status-healthy' : ''}`}>
                {stat.value}
              </div>
              <div className="stat-label">{stat.label}</div>
              {stat.detail && <div className="stat-detail">{stat.detail}</div>}
            </div>
          ))}
        </div>
      </section>

      {/* Pending Actions */}
      <section className="dashboard-section">
        <div className="section-header">
          <h2 className="section-title">
            Pending Actions 
            <span className="badge badge-warning">{PENDING_ACTIONS.length}</span>
          </h2>
          <button className="btn btn-secondary">View All →</button>
        </div>
        
        <div className="pending-actions">
          {PENDING_ACTIONS.map((action) => (
            <div key={action.id} className="action-card card">
              <div className="action-header">
                <span className="action-icon">
                  {action.type === 'device.link' ? '📱' : '👥'}
                </span>
                <span className="action-title">{action.title}</span>
                <span className="badge badge-warning">⏳ Awaiting</span>
              </div>
              <p className="action-description">{action.description}</p>
              <div className="action-footer">
                <span className="action-time">Requested: {action.timestamp}</span>
                <div className="action-buttons">
                  <button className="btn btn-primary">Approve with Spark</button>
                  <button className="btn btn-secondary">Deny</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Recent Activity */}
      <section className="dashboard-section">
        <h2 className="section-title">Recent Activity</h2>
        <div className="activity-list card">
          {RECENT_ACTIVITY.map((item, i) => (
            <div key={i} className="activity-item">
              <span className="activity-icon">✓</span>
              <span className="activity-event">{item.event}</span>
              <span className="activity-time">{item.time}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
